import { Autoplay, Keyboard, Mousewheel, Navigation } from 'swiper/modules'
import Swiper from 'swiper'

class TrustpilotSlider extends HTMLElement {
  constructor() {
    super()

    const trustpilotSliderElement = this
    const swiperHolder = trustpilotSliderElement.querySelector('.swiper')
    const enableLoop = trustpilotSliderElement.getAttribute('data-loop')
    const enableAutoplay = trustpilotSliderElement.getAttribute('data-autoplay')
    const autoplaySpeed = trustpilotSliderElement.getAttribute('data-autoplay-speed')
    const enableKeyboard = trustpilotSliderElement.getAttribute('data-keyboard')
    const swiperButtonNext = trustpilotSliderElement.querySelector('.swiper-button-next')
    const swiperButtonPrevious = trustpilotSliderElement.querySelector('.swiper-button-previous')
    const mobileBreakpoint = 320
    const desktopBreakpoint = 640
    const swiperConfig = {
      modules: [Mousewheel, Navigation],
      mousewheel: {
        forceToAxis: true,
      },
      direction: 'horizontal',
      navigation: {
        enabled: true,
        nextEl: swiperButtonNext,
        prevEl: swiperButtonPrevious,
      },
      threshold: 10,
      edgeSwipeDetection: true,
      breakpoints: {
        // when window width is >= 320px
        [mobileBreakpoint]: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        // when window width is >= 480px
        [desktopBreakpoint]: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
      },
    }

    if (enableAutoplay && enableAutoplay === 'true') {
      swiperConfig.modules = swiperConfig.modules ? [...swiperConfig.modules, Autoplay] : [Autoplay]
    }

    if (enableLoop && enableLoop === 'true') {
      swiperConfig.loop = true
    }

    if (autoplaySpeed && autoplaySpeed > 0) {
      swiperConfig.autoplay = {
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
        delay: autoplaySpeed,
      }
    }

    if (enableKeyboard && enableKeyboard === 'true') {
      swiperConfig.modules = swiperConfig.modules ? [...swiperConfig.modules, Keyboard] : [Keyboard]
      swiperConfig.keyboard = {
        enabled: true,
      }
    }

    let swiper = new Swiper(swiperHolder, swiperConfig)

    window.addEventListener('shopify:section:load', () => new Swiper(swiperHolder, swiperConfig))

    if (matchMedia('screen and (min-width: 768px)').matches) {
      swiper = new Swiper(swiperHolder, swiperConfig)
    } else {
      swiper?.updateSlides()
      swiper.destroy()
    }

    window.addEventListener('resize', () => {
      if (matchMedia('screen and (min-width: 768px)').matches) {
        swiper = new Swiper(swiperHolder, swiperConfig)
      } else {
        swiper?.updateSlides()
        swiper.destroy()
      }
    })

  }
}

// Check if element is defined, if not define it.
// eslint-disable-next-line no-undefined
if (customElements.get('trustpilot-slider') === undefined) {
  customElements.define('trustpilot-slider', TrustpilotSlider)
}